import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentList24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDocumentList24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 20.5H7A1.5 1.5 0 0 1 5.5 19V5A1.5 1.5 0 0 1 7 3.5h5.01v7h6.49V19a1.5 1.5 0 0 1-1.5 1.5M18.5 9a.5.5 0 0 0-.153-.355l-4.836-4.65V9zm.886-1.436-5.205-5.006A2 2 0 0 0 12.794 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9.005a2 2 0 0 0-.614-1.441M10.75 16.75a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H11.5a.75.75 0 0 1-.75-.75m.75-4.25a.75.75 0 0 0 0 1.5h3.75a.75.75 0 0 0 0-1.5zm-2 .75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 4.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentList24);
